export function getAvailableQuantity({
  quantity,
  inProductionQuantity,
  inReserveQuantity
}) {
  return (quantity || 0) + (inProductionQuantity || 0) - (inReserveQuantity || 0);
}